import { atom } from 'jotai';
import { getColors } from '../utils/substancesAndColors';

export const colorsState = atom(getColors());